module.exports = fox._r("images/bg-img-2.jpg", __webpack_public_path__ + "images/bg-img-2.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/bg-img-2.jpg
// module id = 989
// module chunks = 4